// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3FSUV","emails":"CreateEditClinics_emails__1JLfu","emailTagLabel":"CreateEditClinics_emailTagLabel__2CKFa"};